import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface IActionButtonsProps {
  params: any;
  setItemToDestroy: (id: string) => void;
  editLink?: string;
  editFunction?: (data?: any) => void;
}

const ActionButtons: FC<IActionButtonsProps> = ({ params, setItemToDestroy, editLink, editFunction }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      <IconButton size="small" onClick={handleMenuOpen} aria-label="Ações">
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            elevation: 8,
            sx: {
              minWidth: 172,
              mt: 0.5,
              overflow: 'visible',
            },
          },
        }}
        MenuListProps={{ dense: true, sx: { py: 0.5 } }}
      >
        <MenuItem
          onClick={() => {
            if (editFunction) {
              editFunction(params.row);
            } else if (editLink) {
              navigate(editLink);
            }
            handleMenuClose();
          }}
        >
          <ListItemIcon sx={{ minWidth: 32 }}>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ whiteSpace: 'nowrap' }}>Editar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setItemToDestroy(params.row.id);
            handleMenuClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <ListItemIcon sx={{ minWidth: 32, color: 'error.main' }}>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ whiteSpace: 'nowrap' }}>Excluir</ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export { ActionButtons };
